import React, { Component } from "react";
import { Link } from "react-router-dom";
import { decodeFullpath } from "../utilities/utilities";
import "./Breadcrumbs.css";
import { IconArchive, IconBriefcase, IconTrash } from "@tabler/icons-react";
import {
	getDisabledStateFromLifecycleStatuses,
	TRASH_LIFECYCLE_STATUS,
	ARCHIVE_LIFECYCLE_STATUS,
} from "../utilities/lifecycleStatus";

function remapPath(path, name, replacedThing = "/docs/") {
	var joined = path + name;
	var regexp = RegExp(`^${replacedThing}?`);
	return joined.replace(regexp, "");
	//basically just remove "docs" from the full path
}

const splitPath = (
	basepath,
	basepathname,
	linkEachComponent,
	directoryHierarchy
) => {
	var buildup = basepath;
	let haveFoundMostParentalNonNormalDirectory = false;
	return (
		<div>
			<span className="breadcrumbEl" key={buildup}>
				<Link to={basepath}>{basepathname}</Link>
			</span>
			{directoryHierarchy && directoryHierarchy.length > 0
				? directoryHierarchy.map((item, index) => {
						const { name, folderLifecycleStatus } = item;
						if (name !== "") {
							buildup += name + "/";
							let mostParentalNonNormalStatus = null;
							if (
								!haveFoundMostParentalNonNormalDirectory &&
								(folderLifecycleStatus ===
									TRASH_LIFECYCLE_STATUS ||
									folderLifecycleStatus ===
										ARCHIVE_LIFECYCLE_STATUS)
							) {
								haveFoundMostParentalNonNormalDirectory = true;
								mostParentalNonNormalStatus =
									folderLifecycleStatus;
							}
							if (
								!linkEachComponent &&
								index === directoryHierarchy.length - 1
							) {
								return (
									<span
										className="breadcrumbEl"
										key={buildup}
									>
										<span>
											{mostParentalNonNormalStatus ===
												TRASH_LIFECYCLE_STATUS && (
												<>
													<IconTrash
														size={20}
														style={{
															verticalAlign:
																"text-bottom",
														}}
													/>{" "}
												</>
											)}
											{mostParentalNonNormalStatus ===
												ARCHIVE_LIFECYCLE_STATUS && (
												<>
													<IconArchive
														size={20}
														style={{
															verticalAlign:
																"text-bottom",
														}}
													/>{" "}
												</>
											)}
											{decodeFullpath(name)}
										</span>
									</span>
								);
							} else {
								return (
									<span
										className="breadcrumbEl"
										key={buildup}
									>
										<Link to={buildup}>
											<span>
												{mostParentalNonNormalStatus ===
													TRASH_LIFECYCLE_STATUS && (
													<>
														<IconTrash
															size={20}
															color="#727272"
															style={{
																verticalAlign:
																	"sub",
															}}
														/>{" "}
													</>
												)}
												{mostParentalNonNormalStatus ===
													ARCHIVE_LIFECYCLE_STATUS && (
													<>
														<IconArchive
															size={20}
															color="#727272"
															style={{
																verticalAlign:
																	"sub",
															}}
														/>{" "}
													</>
												)}
												{decodeFullpath(name)}
											</span>
										</Link>
									</span>
								);
							}
						} else {
							return null;
						}
					})
				: null}
		</div>
	);
};
class Breadcrumbs extends Component {
	render() {
		let directoryHierarchy = this.props.directoryHierarchy?.length
			? this.props.directoryHierarchy.slice(1)
			: [];
		return (
			<div className="Breadcrumbs" style={this.props.style || null}>
				{" "}
				{splitPath(
					this.props.basepath,
					this.props.basepathname,
					this.props.linkEachComponent,
					directoryHierarchy
				)}
			</div>
		);
	}
}

const BreadcrumbsWithMatterName = (props) => {
	const firmdocsNameMap = { public: "Public ", private: "Private " };
	const pathJoin = props.path + props.name;
	const rootPath = pathJoin.split("/")[1];
	const wordPrefix = firmdocsNameMap[rootPath];

	const matterName =
		props.matterID > 0
			? props.matterName || ""
			: `${wordPrefix || ""}Firm Documents`;

	const matterLink =
		props.matterID > 0
			? `/matters/${props.matterID}/${rootPath}/`
			: `/firmDocs/${rootPath}/`;

	const matterNameAsLink = (
		<Link to={matterLink} className="MainFontBold">
			{matterName}
		</Link>
	);
	const matterNameToDisplay = props.matterNameAsLink
		? matterNameAsLink
		: matterName;
	return (
		<div
			style={{
				display: "flex",
			}}
		>
			<div
				style={{
					display: "flex",
				}}
			>
				<div
					title={matterName}
					style={{
						maxWidth: 300,
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "nowrap",
					}}
					className="MainFontBold"
				>
					{props.showMatterIconWithMatterName && (
						<IconBriefcase
							size={16}
							style={{
								verticalAlign: "text-bottom",
								marginRight: 4,
							}}
						/>
					)}
					{(() => {
						const matterStatusObj =
							getDisabledStateFromLifecycleStatuses({
								matterLifecycleStatus:
									props.matterLifecycleStatus,
							});
						const Icon = matterStatusObj.IN_ARCHIVE
							? IconArchive
							: IconTrash;
						return matterStatusObj.disabled ? (
							<>
								<Icon
									size={16}
									color="#727272"
									style={{
										verticalAlign: "sub",
										marginRight: 4,
									}}
								/>
								{matterNameToDisplay}
							</>
						) : (
							<>{matterNameToDisplay}</>
						);
					})()}
				</div>

				<div
					style={{
						marginLeft: 8,
						marginRight: 8,
					}}
				>
					{">"}
				</div>
			</div>
			<NormalizedBreadcrumbs {...props} />
		</div>
	);
};

const NormalizedBreadcrumbs = (props) => {
	if (props.matterID > 0) {
		return (
			<Breadcrumbs
				fullpath={
					props.path &&
					remapPath(props.path, props.name, props.rootPath)
				}
				linkEachComponent
				basepath={
					"/matters/" + props.matterID + (props.rootPath || "/docs/")
				}
				basepathname={props.rootName || "Documents"}
				directoryHierarchy={props.directoryHierarchy}
			/>
		);
	} else if (!props.matterID) {
		const firmdocsNameMap = { public: "Public", private: "Private" };
		const pathJoin = props.path + props.name;
		const rootPath = pathJoin.split("/")[1];
		const wordPrefix = firmdocsNameMap[rootPath];
		const regexp = new RegExp("^/" + rootPath + "/?");
		return (
			<Breadcrumbs
				fullpath={pathJoin.replace(regexp, "")}
				linkEachComponent
				basepath={"/firmDocs/" + rootPath + "/docs/"}
				basepathname={wordPrefix}
				directoryHierarchy={props.directoryHierarchy}
			/>
		);
	} else {
		return null;
	}
};

export default Breadcrumbs;
export { BreadcrumbsWithMatterName };
